module.exports = __webpack_public_path__ + "img/contact_evaluation.dc52eeab.png";